import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const AlternativesModal = ({ isOpen, onClose, type, currentItem, alternatives, onSelect }) => {
  if (!isOpen) return null;

  const isHotel = type === 'hotel';

  return (
    <div
      className="fixed inset-0 z-[1040] bg-background/95 backdrop-blur-sm overflow-y-auto"
      onClick={onClose}
    >
      <div className="min-h-screen p-4 md:p-6 lg:p-8">
        <div
          className="max-w-4xl mx-auto bg-card rounded-2xl shadow-2xl overflow-hidden"
          onClick={(e) => e?.stopPropagation()}
        >
          {/* Header */}
          <div className="bg-gradient-to-r from-[#2E8B8B] to-[#F4A261] p-6 text-white">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Icon name={isHotel ? 'Hotel' : 'UtensilsCrossed'} size={28} />
                <div>
                  <h3 className="text-2xl font-bold">Alternative Options</h3>
                  <p className="text-sm opacity-90">Currently selected: {currentItem?.name}</p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-all"
              >
                <Icon name="X" size={20} />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="p-6 max-h-[70vh] overflow-y-auto">
            {alternatives?.length === 0 ? (
              <div className="text-center py-12">
                <Icon name="Search" size={48} className="text-muted-foreground mx-auto mb-4" />
                <p className="text-muted-foreground">No alternative options available</p>
              </div>
            ) : (
              <div className="space-y-4">
                {alternatives?.map((item) => (
                  <div
                    key={item?.id}
                    className="bg-background rounded-xl border border-border p-5 hover:shadow-md transition-all"
                  >
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1">
                        <div className="flex items-start justify-between mb-3">
                          <div>
                            <h4 className="text-lg font-semibold text-foreground mb-2">
                              {item?.name}
                            </h4>
                            <div className="flex items-center gap-2 flex-wrap">
                              <span className={`px-2 py-1 text-xs font-medium rounded ${
                                isHotel 
                                  ? 'bg-[#2E8B8B]/10 text-[#2E8B8B]' 
                                  : 'bg-[#F4A261]/10 text-[#F4A261]'
                              }`}>
                                {isHotel ? item?.category : item?.cuisine}
                              </span>
                              <div className="flex items-center gap-1">
                                <Icon name="Star" size={14} className="text-yellow-500 fill-yellow-500" />
                                <span className="text-sm font-medium">{item?.rating}</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="space-y-2 mb-4">
                          <div className="flex items-start gap-2">
                            <Icon name="MapPin" size={16} className="text-muted-foreground mt-0.5" />
                            <p className="text-sm text-muted-foreground">{item?.location}</p>
                          </div>
                          <p className="text-sm text-muted-foreground">{item?.description}</p>
                          
                          <div className="flex flex-wrap gap-2">
                            {(isHotel ? item?.amenities : item?.specialties)?.slice(0, 4)?.map((feature, index) => (
                              <span key={index} className="px-2 py-1 bg-muted text-xs rounded">
                                {feature}
                              </span>
                            ))}
                          </div>
                        </div>

                        <div className="flex items-center justify-between pt-4 border-t border-border">
                          <div>
                            <p className="text-xs text-muted-foreground">Total Cost</p>
                            <p className="text-xl font-bold text-foreground">
                              ₱{item?.totalCost?.toLocaleString()}
                            </p>
                            {isHotel && (
                              <p className="text-xs text-muted-foreground">
                                ₱{item?.pricePerNight?.toLocaleString()} per night
                              </p>
                            )}
                          </div>
                          <Button
                            variant="default"
                            size="sm"
                            iconName="Check"
                            onClick={() => onSelect(item)}
                            className="bg-gradient-to-r from-[#2E8B8B] to-[#F4A261]"
                          >
                            Select This
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlternativesModal;